module.exports = __webpack_public_path__ + "static/media/staging-qr.23db459a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staging-qr.png
// module id = 712
// module chunks = 21